module.exports = __webpack_public_path__ + "static/media/heart-author.d4046a32.svg";